import { IComponentId } from '@/services/component';
import messages from '../messages';

export default function(
  this: any,
  id: IComponentId,
  name: string,
): Promise<boolean> {
  const { commit, dispatch, state } = (this as any).$store;

  return new Promise(resolve => {
    commit('dialog/CREATE', {
      title: 'Delete vendor?',
      content: this.$formatMessage(
        messages.VENDOR_DELETE_ASK,
        name,
      ),
      compact: true,
      buttons: [{
        text: 'No, don\'t delete',
        click: (dialog: any) => {
          resolve(false);
          dialog.close();
        },
      }, {
        text: 'Yes, delete',
        click: (dialog: any) => {
          const moduleName = state.vendors ? 'vendors' : 'vendor';
          commit('loader/ADD', {
            title: this.$formatMessage(
              messages.VENDOR_DELETE_CONFIRM,
              name,
            ),
            promise: dispatch(`${moduleName}/remove`, id)
              .then(() => {
                resolve(true);
                dialog.close();
              }, () => {
                commit('dialog/CREATE', {
                  title: 'Error :(',
                  content: messages.ERROR_VENDOR_DELETE,
                  compact: true,
                  buttons: [{
                    text: 'Close',
                    click: (subDialog: any) => subDialog.close(),
                  }],
                });
              }),
          });
        },
      }],
    });
  });
}
